/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
/* eslint-disable import/no-duplicates */
import { BrandButton } from '@zapier/design-system';
import type { IconName } from '@zapier/design-system';

type Props = {
  /**
   * Where the `Button` links to.
   */
  href: string;
  /**
   * Name of the icon to render when `isCollapsed`.
   */
  iconName: IconName;
  /**
   * Indicates whether the button is collapsed.
   */
  isCollapsed: boolean;
  /**
   * The content of the button, which will also be used
   * for the `ariaLabel` when `isCollapsed`.
   */
  text: string;
};

const UniversalSidebarSubheaderButton = (props: Props) => {
  // Use `Button` for both the text and `Icon` states
  // instead of `IconButton` so that the component can visually
  // transition from one state to the other. With `IconButton`,
  // the components would unmount and remount the next one.
  return (
    <BrandButton
      ariaLabel={props.text}
      iconBefore={props.iconName}
      hasShadow={true}
      href={props.href}
      isFullWidth={true}
      {...(props.isCollapsed && { color: 'brand-nav' })}
      size="medium"
    >
      {!props.isCollapsed && props.text}
    </BrandButton>
  );
};

export default UniversalSidebarSubheaderButton;
